'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, FC, ReactNode, useContext, useMemo } from 'react';
import { StorefrontFeature } from '@ordering/gql/graphql';
import { isMenuBrowsingOnly, isOrderingEnabled } from '@ordering/utils/storefrontFeatures';
type FeaturesContextValue = {
  features: StorefrontFeature[];
  hasFeature: (feature: StorefrontFeature) => boolean;
  isOrderAndPayStore: boolean;
  isDigitalMenuStore: boolean;
};
const orderingEnabledValue: FeaturesContextValue = {
  features: [],
  hasFeature: () => true,
  isOrderAndPayStore: true,
  isDigitalMenuStore: false
};
const FeaturesContext = createContext<FeaturesContextValue>(orderingEnabledValue);
export const FeaturesProvider: FC<{
  children: ReactNode;
  features: StorefrontFeature[];
}> = t0 => {
  const $ = _c(13);
  const {
    children,
    features
  } = t0;
  let t1;
  let t2;
  if ($[0] !== features) {
    t1 = feature => features.includes(feature);
    t2 = isOrderingEnabled(features);
    $[0] = features;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== features) {
    t3 = isMenuBrowsingOnly(features);
    $[3] = features;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== features || $[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      features,
      hasFeature: t1,
      isOrderAndPayStore: t2,
      isDigitalMenuStore: t3
    };
    $[5] = features;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const value = t4;
  let t5;
  if ($[10] !== children || $[11] !== value) {
    t5 = <FeaturesContext.Provider value={value}>{children}</FeaturesContext.Provider>;
    $[10] = children;
    $[11] = value;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export const useFeatures = () => {
  return useContext(FeaturesContext);
};